import { useEffect, useState } from 'react';
import MenuSection from '../components/MenuSection';
import { PalmTree, BananaLeaf, OrnateDivider } from '../components/KeralaDecor';
import menu from '../data/menu';
import site from '../data/site';
import './MenuPage.css';

export default function MenuPage() {
  const [activeId, setActiveId] = useState(menu[0].id);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const observers = [];
    menu.forEach((s) => {
      const el = document.getElementById(s.id);
      if (!el) return;
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) setActiveId(s.id);
          });
        },
        { rootMargin: '-30% 0px -55% 0px', threshold: 0 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  const handleJump = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.style.animation = 'sectionHighlight 1s ease-out';
    setTimeout(() => { el.style.animation = ''; }, 1000);
  };

  return (
    <main
      className="menu-page"
      style={{ backgroundImage: 'url(/decor/parchment-noise.svg)' }}
    >
      {/* Hero */}
      <section className="menu-hero">
        <PalmTree side="left" height={300} opacity={0.22} />
        <PalmTree side="right" height={300} opacity={0.22} />
        <div className="container menu-hero__inner">
          <span className="eyebrow-script">Flavors of Malabar</span>
          <h1 className="menu-hero__title">Our Menu</h1>
          <OrnateDivider />
          <p className="menu-hero__lead">
            Please call for special requests. We love a custom order.
          </p>
          <div className="menu-hero__phones">
            {site.phones.map((p) => (
              <a key={p.tel} href={`tel:${p.tel}`} className="menu-hero__phone">📞 {p.display}</a>
            ))}
          </div>
        </div>
      </section>

      {/* Sticky category nav */}
      <nav className="menu-cats" aria-label="Menu categories">
        <div className="container menu-cats__inner">
          {menu.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              onClick={(e) => handleJump(e, s.id)}
              className={'menu-cats__link' + (activeId === s.id ? ' is-active' : '')}
            >
              {s.title}
            </a>
          ))}
        </div>
      </nav>

      {/* Sections */}
      <div className="menu-page__body">
        <BananaLeaf position="top-left" size={300} opacity={0.32} />
        <BananaLeaf position="top-right" size={300} opacity={0.32} mirror />
        <BananaLeaf position="bottom-left" size={300} opacity={0.32} mirror />
        <BananaLeaf position="bottom-right" size={300} opacity={0.32} />

        <div className="container menu-page__sections">
          {menu.map((section) => (
            <MenuSection key={section.id} section={section} />
          ))}
        </div>
      </div>

      {/* Special requests */}
      <section className="menu-requests">
        <div className="container menu-requests__inner">
          <span className="eyebrow-script">Special Requests</span>
          <h2>Don't see what you're looking for?</h2>
          <p>Call us. If it's in the kitchen, we'll cook it.</p>
          <div className="menu-requests__cta">
            {site.phones.map((p) => (
              <a key={p.tel} href={`tel:${p.tel}`} className="btn btn-gold">📞 {p.display}</a>
            ))}
          </div>
          <p className="menu-requests__addr">
            <a href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer">
              {site.address.line1}, {site.address.line2}
            </a>
          </p>
        </div>
      </section>
    </main>
  );
}
